// extracted by mini-css-extract-plugin
export default {"container":"TableLoader__container-vnIwZ","sticky":"TableLoader__sticky-c5I7D"};